/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { UsersStrictHttpResponse } from '../../users-strict-http-response';
import { UsersRequestBuilder } from '../../users-request-builder';

import { UsersUserResponseDto } from '../../models/users-user-response-dto';

export interface UsersControllerFindAllByTenant$Params {

/**
 * Tenant ID
 */
  tenant: string;
}

export function usersControllerFindAllByTenant(http: HttpClient, rootUrl: string, params: UsersControllerFindAllByTenant$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<Array<UsersUserResponseDto>>> {
  const rb = new UsersRequestBuilder(rootUrl, usersControllerFindAllByTenant.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as UsersStrictHttpResponse<Array<UsersUserResponseDto>>;
    })
  );
}

usersControllerFindAllByTenant.PATH = '/o2-users/users/{tenant}';
